import { render, staticRenderFns } from "./ContactEditPriceRules.vue?vue&type=template&id=307ddb68"
import script from "./ContactEditPriceRules.vue?vue&type=script&lang=ts"
export * from "./ContactEditPriceRules.vue?vue&type=script&lang=ts"
import style0 from "./ContactEditPriceRules.vue?vue&type=style&index=0&id=307ddb68&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307ddb68')) {
      api.createRecord('307ddb68', component.options)
    } else {
      api.reload('307ddb68', component.options)
    }
    module.hot.accept("./ContactEditPriceRules.vue?vue&type=template&id=307ddb68", function () {
      api.rerender('307ddb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEditPriceRules.vue"
export default component.exports